import { useEffect, useState } from 'react';

import type { SourceType, IHandlerProps } from '/shared/FilePreview/types';
import { ProcessPreview } from '/shared/FilePreview/ProcessPreview';

export function FileHandler({ source, ...rest }: IHandlerProps<File>) {
  const [url, setUrl] = useState<string | undefined>();
  useEffect(() => {
    const objectUrl = URL.createObjectURL(source);
    setUrl(objectUrl);

    return () => {
      URL.revokeObjectURL(objectUrl);
    };
  }, [source]);

  if (!url) return null;

  return <ProcessPreview url={url} type={source.type} {...rest} />;
}

FileHandler.canProcess = (source: SourceType): boolean => source instanceof File;
